import React, { useEffect, useState } from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import './videoviewer.scss';
import { getSignedUrl } from "../../../backend/upload_file";
import ReactPlayer from 'react-player/lazy'
import download_icon from "../../../../assets/icons/download.svg";

export default function VideoViewer({ url }) {

    const [signedUrl, setSignedUrl] = useState("");
    const [loadingSignedUrl, setLoadingSignedUrl] = useState(true)

    useEffect(() => {        
        if(url.length > 0) {
            getSignedUrl(
                url
            ).then((res) => {
                setSignedUrl(res.data.signedUrl);
                setTimeout(() => {
                    setLoadingSignedUrl(false);
                }, 2500);
                
            }).catch(error => {
                setSignedUrl("")
            });
        }
         
    }, [url]);

    const downloadFile = () => {
        
        const url_download = signedUrl 

        const link = document.createElement('a');

        //console.log('url ->', url_download)
        link.setAttribute('href', url_download)
        link.setAttribute('download', `prueba`)
        link.setAttribute('target', '_blank');

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

    }

    return (
        <div className="video-viewer">
            { 
                loadingSignedUrl ? 
                    <div className="loading-indicator">
                        <LoadingIndicator size={50} color="var(--color-primary-dark)" loading={loadingSignedUrl} />
                    </div>
                    
                :
                <>
                    <ReactPlayer
                        className='react-player'
                        url={signedUrl}                        
                        width='80%'
                        height='100%'
                        controls={true}
                        onReady={() => {
                            //console.log('Video cargado')
                        }}
                        />
                    <div className='actions'>
                        <button className="btn_primary" onClick={() => downloadFile()}>
                            <img src={download_icon} alt='Descargar' />
                            DESCARGAR
                        </button>
                    </div>
                </>
                    
            }
        </div>
    );
}
